import { useMutation } from "react-query";
import servicesUtils from "../../utils/servicesUtils";

function useAgreementService() {
  const url = "/agreement/accept/";
  return useMutation((version: string) => servicesUtils.postService(url, { version }));
}

export default useAgreementService